module.exports = __webpack_public_path__ + "img/pageinteriors_04asesoria-en-siniestros-02.5e9496a6.jpg";